<template>
  <SplitButton
    :label="label"
    :class="ButtonClass()"
    :style="{
      height: `${height}`,
      width: `${width}`,
      border: `1px solid ${color} !important`,
      color: `${color}`,
      background: `${bgcolor}`,
    }"
    :icon="icon"
    :iconPos="iconPos"
    dropdownIcon="pi pi-cog"
  />
</template>

<script>
import SplitButton from 'primevue/splitbutton';

export default {
  name: 'SplitButtons',
  props: ['label', 'icon', 'button_class', 'type', 'bgcolor', 'color', 'height', 'width', 'iconPos'],
  components: {
    SplitButton,
  },
  methods: {
    ButtonClass() {
      const classes = [];
      classes.push(this.button_class);
      if (this.type === 'primary') {
        classes.push('primary-btn');
      }
      if (this.type === 'secondary') {
        classes.push('secondary-btn');
      }
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.p-splitbutton {
  :deep(.p-button) {
    border: unset !important;
    border-radius: 4px !important;
    font-size: 14px !important;

    &:enabled:focus {
      box-shadow: none !important;
    }
  }

  :deep(.p-splitbutton-defaultbutton) {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  :deep(.p-splitbutton-menubutton) {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
}

.primary-btn {
  :deep(.p-button) {
    color: $primary-button-text-color;
    background: $primary-color;
    &:enabled:hover {
      background-color: darken($primary-color, 5%) !important;
    }
    &:enabled:active {
      background-color: darken($primary-color, 10%) !important;
    }
  }
}

.secondary-btn {
  :deep(.p-button) {
    color: $white-color;
    background: $secondary_color;
    &:enabled:hover {
      background: $secondary_color !important;
      color: $side-bar-active-color;
    }
    &:enabled:active {
      background: $secondary_color !important;
      color: $side-bar-active-color;
    }
  }
}
</style>
